import React from "react";
import { useTranslate } from "../../i18n/useTranslate";

// Shared Recharts tooltip content — replaces the unstyled default Recharts
// tooltip box used everywhere in the app. Usage: <Tooltip content={<ChartTooltip />} />
// or <Tooltip content={<ChartTooltip formatter={(v, name) => [fmt(v), name]} />} />.
export default function ChartTooltip({ active, payload, label, formatter, labelFormatter }) {
  const t = useTranslate();
  if (!active || !payload?.length) return null;

  const rows = payload.filter((p) => p.value !== undefined && p.value !== null);
  if (!rows.length) return null;

  return (
    <div className="bg-slate-900/95 text-white rounded-xl shadow-xl px-3 py-2 min-w-[120px]">
      {label !== undefined && (
        <div className="text-[9px] font-bold text-slate-400 uppercase tracking-wide mb-1">
          {labelFormatter ? labelFormatter(label) : t(label)}
        </div>
      )}
      <div className="space-y-1">
        {rows.map((p, i) => {
          const [val, name] = formatter ? formatter(p.value, p.name, p) : [p.value, p.name];
          return (
            <div key={p.dataKey ?? i} className="flex items-center justify-between gap-3 text-[11px]">
              <span className="flex items-center gap-1.5 text-slate-300 truncate">
                <span className="w-2 h-0.5 rounded-full flex-shrink-0" style={{ background: p.color || p.stroke || p.fill }} />
                {t(name)}
              </span>
              <span className="font-bold text-white tabular-nums">{val}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
